export default __webpack_public_path__ + "static/media/todoAppDesign.6e353b08.png";